import { ToastAction } from '@/components/ui/toast';
import { toast } from '@/components/ui/use-toast';
import { BILLING_PATH } from '@/lib/entitlements';

/**
 * "Your plan doesn't include this" — one toast, with a See plans button to Billing, used wherever
 * the builder refuses something the plan doesn't include (lib/entitlements.ts). Not the red error
 * style: nothing went wrong, the plan just doesn't include it.
 */
export function showUpgradeToast(navigate: (path: string) => void, description: string, title = 'Upgrade to add this'): void {
  toast({
    title,
    description,
    action: (
      <ToastAction altText="See plans" onClick={() => navigate(BILLING_PATH)}>
        See plans
      </ToastAction>
    ),
  });
}
